import { Toggle as BaseToggle } from '@base-ui/react/toggle';
import type { ComponentProps } from 'react';
import { cx } from '../lib/styled.tsx';

export type ToggleProps = ComponentProps<typeof BaseToggle>;

/** A button that stays pressed — bold in a text toolbar, a filter chip in a list. */
export function Toggle({ className, ...props }: ToggleProps) {
  return (
    <BaseToggle
      className={cx(
        'inline-flex h-8 min-w-8 items-center justify-center gap-1.5 rounded-full px-4',
        'text-bodysm font-semibold text-ink-muted',
        'transition-[background-color,color,box-shadow] duration-150 ease-out-quint',
        'hover:not-data-disabled:text-ink',
        // Pressed is a white pill lifted off the track, which is what makes a
        // row of these read as a segmented control rather than as buttons.
        'data-pressed:bg-surface-raised data-pressed:text-ink data-pressed:shadow-button',
        'data-disabled:cursor-not-allowed data-disabled:text-ink-faint',
        className,
      )}
      {...props}
    />
  );
}
